export class ClassificationFieldExternalId {
    public id: string;
    public externalIdId: string;
    public classificationId: string;
    public value: string;
}
